import React from "react";
import { stateType } from "../../state";
import {
	BOX_SHADOWS,
	DATA_TYPES,
	FONTS,
	PRIMARY_COLOR,
	SECONDARY_COLOR,
} from "../../constants";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { BoxHeader } from "../Common/BoxHeader";
import { Chart } from "react-google-charts";
import { BAR_COLORS, getBarColors } from "../VariableCorrelations/DualChart";
import { ChartXTitle, ChartYTitle } from "../CohortAnalysis/Charts/ColumnChart";
import MenuItem from "@material-ui/core/MenuItem";
import { KeyboardArrowDown } from "@material-ui/icons";
import Menu from "@material-ui/core/Menu";
import { trimString } from "../Common/helpers";
import { HelpIcon } from "../Common/ToolTipIcon";
import { formatNumber } from "../../helpers/FormatNumber";
import Column from "../../MachineLearning/Column";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		dropDown: {
			width: "140px",
			height: "30px",
			border: "solid",
			marginLeft: "20px",
			borderRadius: "5px",
			borderColor: "rgba(0,0,0,0.2)",
			borderWidth: "2px",
			marginTop: "-5px",
			display: "flex",
			flexDirection: "row",
			transition: "0.3s",
			cursor: "pointer",
			backgroundColor: "white",
			"&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
		},
		container: {
			display: "flex",
			flexDirection: "column",
			width: "100%",
			backgroundColor: "white",
			boxShadow: BOX_SHADOWS,
			borderRadius: "10px",
			height: "520px",
		},
		chartContainer: {
			width: "94%",
			height: "70%",
			marginLeft: "5%",
		},
		chartContainer2: {
			width: "100%",
			height: "100%",
			display: "flex",
			flexDirection: "column",
			position: "relative",
		},
	})
);

function DropDown({ state }: stateType) {
	const classes = useStyles();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	if (state.saveState.variableImportance.impactVarSelected === undefined) {
		return <div></div>;
	}

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuSelect = (e) => {
		const columnName = e.target.id as string;
		const col = state.saveState.dataset.getColumn(columnName);
		if (col !== undefined) {
			if (
				columnName !==
				state.saveState.variableImportance.impactVarSelected
			) {
				state.saveState.variableImportance.impactVarSelected =
					columnName;
				state.setSaveState(state.saveState);
			}
		}

		setAnchorEl(null);
	};

	let colNames: string[] = [];
	for (let col of state.saveState.dataset.columns) {
		if (
			col.columnName in state.saveState.variableImportance.varImportance
		) {
			colNames.push(col.columnName);
		}
	}

	colNames = colNames.sort((a, b) =>
		a.toLowerCase() < b.toLowerCase() ? -1 : 1
	);

	return (
		<div className={classes.dropDown}>
			<div
				onClick={(event: any) => handleClick(event)}
				style={{
					width: "100%",
					height: "100%",
					textAlign: "left",
					lineHeight: "30px",
					marginLeft: "10px",
				}}
			>
				{trimString(
					state.saveState.variableImportance.impactVarSelected,
					11
				)}
			</div>
			<KeyboardArrowDown
				style={{
					marginTop: "4px",
					width: "22px",
					height: "22px",
					left: "-4px",
				}}
			></KeyboardArrowDown>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				style={{
					marginTop: "43px",
					marginLeft: "-90px",
					maxWidth: "400px",
				}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
			>
				{colNames.map((colName) => (
					<MenuItem
						style={{ width: "190px" }}
						onClick={handleMenuSelect}
						id={colName}
					>
						{colName}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
}

function DropDown2({ state }: stateType) {
	const classes = useStyles();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuSelect = (e) => {
		const className = e.target.id as string;
		state.saveState.variableImportance.impactClassSelected = className;
		state.setSaveState(state.saveState);
		setAnchorEl(null);
	};

	let yCol = state.saveState.dataset.getColumn(
		state.saveState.modelTraining.valueToPredict
	);
	if (yCol === undefined) {
		return <div></div>;
	}
	let yClasses = Array(Column.getNClasses(yCol))
		.fill(0)
		.map((y, i) => yCol.getClassByIndex(i, true));

	return (
		<div className={classes.dropDown}>
			<div
				onClick={(event: any) => handleClick(event)}
				style={{
					width: "100%",
					height: "100%",
					textAlign: "left",
					lineHeight: "30px",
					marginLeft: "10px",
				}}
			>
				{trimString(
					state.saveState.variableImportance.impactClassSelected,
					11
				)}
			</div>
			<KeyboardArrowDown
				style={{
					marginTop: "4px",
					width: "22px",
					height: "22px",
					left: "-4px",
				}}
			></KeyboardArrowDown>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				style={{
					marginTop: "43px",
					marginLeft: "-90px",
					maxWidth: "400px",
				}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
			>
				{yClasses.map((colName) => (
					<MenuItem
						style={{ width: "190px" }}
						onClick={handleMenuSelect}
						id={colName}
					>
						{colName}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
}

export function ImpactDropdown({ state }: stateType) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				marginLeft: "20px",
			}}
		>
			<div style={{ fontFamily: FONTS, fontWeight: "bold" }}>
				{"Impact Variable"}
			</div>
			<div style={{ fontFamily: FONTS, fontWeight: "bold" }}>:</div>
			<div style={{ marginLeft: "-10px" }}>
				<DropDown state={state}></DropDown>
			</div>
			<HelpIcon
				title={
					"Choose the variable you want to measure the impact of on your target variable."
				}
				marginLeft={"8px"}
			></HelpIcon>
		</div>
	);
}

export function ClassSelectDropdown({ state }: stateType) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				marginLeft: "40px",
			}}
		>
			<div style={{ fontFamily: FONTS, fontWeight: "bold" }}>
				{state.saveState.modelTraining.valueToPredict}
			</div>
			<div style={{ fontFamily: FONTS, fontWeight: "bold" }}></div>
			<div style={{ fontFamily: FONTS, fontWeight: "bold" }}>:</div>
			<div style={{ marginLeft: "-10px" }}>
				<DropDown2 state={state}></DropDown2>
			</div>
			<HelpIcon
				title={`Choose the class of '${state.saveState.modelTraining.valueToPredict}' you want to plot.`}
				marginLeft={"8px"}
			></HelpIcon>
		</div>
	);
}

function NumericOutputChart({ state }: stateType) {
	const classes = useStyles();
	let varImpact =
		state.saveState.variableImportance.varImpact[
			state.saveState.variableImportance.impactVarSelected
		];
	const impactVarCol = state.saveState.dataset.getColumn(
		state.saveState.variableImportance.impactVarSelected
	);
	const yCol = state.saveState.dataset.getColumn(
		state.saveState.modelTraining.valueToPredict
	);

	const varImLen = Object.keys(
		state.saveState.variableImportance.varImportance
	).length;
	if (
		varImLen === 0 ||
		varImpact === undefined ||
		impactVarCol === undefined ||
		yCol === undefined
	) {
		return <div></div>;
	}

	let data: any[] = [["", "", { role: "style" }, { role: "tooltip" }]];

	const isImpactCat = impactVarCol.columnType === DATA_TYPES.categorical;
	const yColIndex =
		yCol.columnType === DATA_TYPES.number
			? 0
			: yCol.getClassIndex(
					state.saveState.variableImportance.impactClassSelected
			  );

	let me = yCol.columnType === DATA_TYPES.categorical ? 100 : 1;
	const isyCat = yCol.columnType === DATA_TYPES.categorical;
	for (let i = 0; i < varImpact.values.length; i++) {
		data.push([
			isImpactCat
				? impactVarCol.getClassByIndex(varImpact.xRange[i], true)
				: varImpact.xRange[i],
			varImpact.values[i][yColIndex],
			`fill-color: ${SECONDARY_COLOR}; fill-opacity: ${0.7}; stroke-color: ${PRIMARY_COLOR}  ; stroke-width: 3;`,
			(isImpactCat
				? impactVarCol.getClassByIndex(varImpact.xRange[i], true)
				: varImpact.xRange[i]) +
				"\n" +
				formatNumber(me * varImpact.values[i][yColIndex]) +
				(isyCat ? "%" : ""),
		]);
	}

	let chartYTitle = state.saveState.modelTraining.valueToPredict;
	const isPercentage = yCol.columnType === DATA_TYPES.categorical;
	if (isPercentage) {
		chartYTitle = `'${state.saveState.modelTraining.valueToPredict}' = ${state.saveState.variableImportance.impactClassSelected} (Probability)`;
	}

	return (
		<div className={classes.chartContainer}>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					marginTop: "10px",
				}}
			>
				<ChartYTitle yName={chartYTitle}></ChartYTitle>
				<div className={classes.chartContainer2}>
					<ChartXTitle
						xName={
							state.saveState.variableImportance.impactVarSelected
						}
					></ChartXTitle>
					<div
						style={{
							height: "100%",
							width: "100%",
							marginLeft: "0%",
						}}
					>
						<Chart
							style={{
								height: "400px",
								width: "100%",
								zIndex: 1000,
							}}
							chartType={"AreaChart"}
							loader={<div>Loading Chart</div>}
							data={data}
							options={{
								// Material design options
								pointSize: 3,
								colors: [PRIMARY_COLOR, PRIMARY_COLOR],
								legend: { position: "none" },
								chartArea: {
									width: "100%",
									height: "100%",
									top: 10,
									right: 40,
									bottom: 60,
									left: 40,
								},

								vAxis: {
									minorGridlines: { color: "white" },
									gridlines: { color: "rgb(220,220,220)" },
									baselineColor: "rgb(220,220,220)",
									format: isPercentage ? "#%" : "#",
								},
								hAxis: {
									minorGridlines: { color: "white" },
									baselineColor: "transparent",
									gridlines: { color: "rgb(220,220,220)" },
								},

								annotations: {
									alwaysOutside: true,
									textStyle: {
										color: PRIMARY_COLOR,
										fontSize: 14,
										fontFamily: FONTS,
									},
								},
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export function VariableImpactBox({ state }: stateType) {
	const classes = useStyles();
	const col = state.saveState.dataset.getColumn(
		state.saveState.modelTraining.valueToPredict
	);
	if (col === undefined) {
		return <div></div>;
	}
	const outputType = col.columnType;

	return (
		<div className={classes.container}>
			<div style={{ display: "flex", flexDirection: "row" }}>
				{" "}
				<BoxHeader
					title={`Impact of '${state.saveState.variableImportance.impactVarSelected}' on '${state.saveState.modelTraining.valueToPredict}'`}
					toolTip={`Shows which variables have the largest relative influence on predicting ${state.saveState.modelTraining.valueToPredict}.`}
					line={false}
				></BoxHeader>
			</div>
			<NumericOutputChart state={state}></NumericOutputChart>
		</div>
	);
}
